import './assets/css/index.css';
import App from './components/app';

export default App;



// WEBPACK FOOTER //
// ./index.js